import { cn } from '@workspace/ui/lib';
import type * as React from 'react';

function Card({
  className,
  disabled,
  selected,
  variant,
  ...props
}: React.ComponentProps<'div'> & {
  disabled?: boolean;
  selected?: boolean;
  variant: 'large' | 'small-left-icon' | 'small-center-icon';
}) {
  return (
    <div
      data-slot="card"
      aria-selected={selected}
      aria-disabled={disabled}
      className={cn(
        'group dark:bg-grey-1000 flex h-fit max-w-[448px] rounded-3xl bg-neutral-100',
        selected
          ? 'bg-pink-25 border border-pink-400 dark:border-pink-200 dark:bg-neutral-200'
          : 'dark:hover:bg-grey-1000 dark:hover:border-grey-700 hover:border-0 hover:bg-pink-50 dark:hover:border',
        disabled && 'bg-grey-100 dark:bg-grey-1000 pointer-events-none border-transparent',
        variant === 'large' && 'min-h-[220px] flex-col items-center justify-end gap-1 p-8',
        variant === 'small-left-icon' && 'min-h-[116px] items-start gap-4 p-8',
        variant === 'small-center-icon' &&
          'min-h-[144px] flex-col items-center justify-end gap-2 px-4 py-6',
        className
      )}
      {...props}
    />
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-title"
      className={cn(
        'group-aria-disabled:text-grey-400 dark:group-aria-disabled:text-grey-800 text-base leading-tight font-medium text-neutral-200 dark:text-neutral-100',
        className
      )}
      {...props}
    />
  );
}

function CardDescription({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & {
  variant: 'large' | 'small-left-icon' | 'small-center-icon';
}) {
  return (
    <div
      data-slot="card-description"
      className={cn(
        'text-grey-700 group-hover:text-grey-900 group-aria-disabled:text-grey-400 group-aria-selected:text-grey-1000 dark:text-grey-600 dark:group-aria-disabled:text-grey-800 dark:group-aria-selected:text-grey-80',
        variant === 'large' && 'text-base leading-normal font-normal',
        variant === 'small-left-icon' && 'text-base leading-normal font-normal',
        variant === 'small-center-icon' && 'text-sm leading-tight font-normal',
        className
      )}
      {...props}
    />
  );
}

export { Card, CardDescription, CardTitle };
